import React from 'react'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import styled from 'styled-components'
import Image from 'common/image'
import DownArrow from 'assets/down-arrow.svg'
import { adobeInteractionEvent } from 'utils/adobewa'

const FaqItemContainer = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 319px;
    padding: 16px 20px;
    background-color: white;
    border-radius: 0 0 25px 25px;
    border-top: 2px solid var(--Brand-Color-Yellow, #c5924d);
    backdrop-filter: blur(15px);
`

const FaqQuestionRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

const FaqQuestionText = styled.div`
    width: 100%;
    color: #000;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

interface Props {
    $display: boolean
}

const FaqAnswerText = styled.div<Props>`
    width: 100%;
    margin-top: 24px;
    color: #000;
    font-size: 16px;
    font-style: normal;
    line-height: 20px; /* 125% */
    display: ${(p) => (p.$display ? '' : 'none')};
`

interface FaqItemProps {
    question: string
    answer: string
    currentTab: string
    isFaqCollapse?: boolean
}

const FaqItem: React.FC<FaqItemProps> = ({
    question,
    answer,
    currentTab,
    isFaqCollapse = true,
}) => {
    const [isCollapse, setIsCollapse] = useState(isFaqCollapse)
    const { i18n } = useTranslation()
    const lang = i18n.language

    const collapseQuestion = (question: string) => {
        if (isCollapse) {
            adobeInteractionEvent({
                lang: lang,
                eventID: `prioritysite_click_Help_${currentTab}_Question`,
                contentTitle: question,
            })
            setIsCollapse(false)
        } else {
            setIsCollapse(true)
        }
    }

    return (
        <FaqItemContainer>
            <FaqQuestionRow
                onClick={() => {
                    collapseQuestion(question)
                }}
            >
                <FaqQuestionText>{question}</FaqQuestionText>
                {isCollapse ? (
                    <Image
                        src={DownArrow}
                        width={24}
                        height={24}
                        alt="Down Arrow"
                    />
                ) : (
                    <Image
                        src={DownArrow}
                        width={24}
                        height={24}
                        style={{ transform: 'rotate(180deg)' }}
                        alt="Down Arrow"
                    />
                )}
            </FaqQuestionRow>
            <FaqAnswerText
                $display={!isCollapse}
                dangerouslySetInnerHTML={{ __html: answer }}
            />
        </FaqItemContainer>
    )
}

export default FaqItem
